import React, { useEffect, useState, useContext } from "react";

import '../../css/customline/main.css';
import '../../css/customline/model.css';
import '../../css/customline/mobile.css';
import '../../css/customline/animate.css';
import '../../css/customline/plug-ins.css';

import Loading from "../Shared/Loading";
import Grid from "@mui/material/Grid";
import { NavMenu } from '../NavMenu';
import Footer from "../Footer/Footer";

import WOW from 'wowjs';

import MainImage from "../Model/MainImage";
import VideoIntro from "../Model/VideoIntro";
import ImageGallery from "../Model/ImageGallery";
import VideoGallery from "../Model/VideoGallery";
import GeneralArrangements from "../Model/GeneralArrangements";
import TechData from "../Model/TechData";
import LocalDoc from "../Model/LocalDoc";
import IntroSection from "../Model/IntroSection";
import ImageAnimation from "../Model/ImageAnimation";
import ImageAnimationDouble from "../Model/ImageAnimationDouble";
import VirtualTour from "../Model/VirtualTour";

export const CatalogCustomLine = (props) => {
    const [loading, setLoading] = useState(true);
    const basicModelId = props.basicModelId;

    const location = "https://digitalcatalog.ferrettigroup.com/CustomLine50";
    const title = "Custom Line 50";

    window.dataLayer.push({
        event: 'pageview',
        page: {
            url: location,
            title: title
        }
    });

    useEffect(() => {
        new WOW.WOW({
            boxClass: 'wow', // default
            animateClass: 'animated', // default
            offset: 0, // default
            mobile: true, // default
            live: false
        }).init();
    }, []);

    return (
        <>
            <NavMenu basicModelId={basicModelId} />
            <Grid container spacing={4} className="vh-100" p={2}>
                <Grid item xs={12} md={12}>
                    <VideoIntro />
                </Grid>
                <Grid item xs={12} md={12} id="dream">
                    <LocalDoc fileName="intro" />
                </Grid>
                <Grid item xs={12} md={12}>
                    <MainImage />
                </Grid>
                <Grid item xs={12} md={12} id="exteriors">
                    <IntroSection title="Exteriors" subtitle="by Filippo Salvetti" />
                </Grid>
                <Grid item xs={12} md={12}>
                    <ImageAnimation type="triangle" />
                </Grid>
                <Grid item xs={12} md={12}>
                    <LocalDoc fileName="cruising" />
                </Grid>
                <Grid item xs={12} md={12}>
                    <ImageGallery gallery="external" template="mini" />
                </Grid>
                <Grid item xs={12} md={12} id="interiors">
                    <IntroSection title="Interiors" subtitle="by Antonio Citterio and Patricia Viel" />
                </Grid>
                <Grid item xs={12} md={12}>
                    <ImageAnimation type="ellipse" />
                </Grid>
                <Grid item xs={12} md={12}>
                    <ImageAnimation type="owner" />
                </Grid>
                <Grid item xs={12} md={12}>
                    <LocalDoc fileName="interiors" />
                </Grid>
                <Grid item xs={12} md={12}>
                    <ImageAnimationDouble />
                </Grid>
                <Grid item xs={12} md={12}>
                    <ImageGallery gallery="internal" template="mini" />
                </Grid>
                <Grid item xs={12} md={12} id="video">
                    <VideoGallery />
                </Grid>
                <Grid item xs={12} md={12} id="vt">
                    <VirtualTour />
                </Grid>
                <Grid item xs={12} md={12} id="arrangements">
                    <GeneralArrangements />
                </Grid>
                <Grid item xs={12} md={12} id="techdata">
                    <TechData />
                </Grid>
                <Grid item xs={12} md={12}>
                    <Footer />
                </Grid>
            </Grid>
        </>
    );
};

export default CatalogCustomLine;
